// extracted by mini-css-extract-plugin
export default {"wrapper":"ScrollArrow_wrapper__KzAH0","arrow":"ScrollArrow_arrow__z2mo+"};